import React from "react"

const AuthFooter = () => {

    return (
        <>
            <div className="tw-flex tw-items-center tw-gap-1 tw-mt-2 tw-text-[16px] tw-text-[#6C757D] tw-font-normal">
                <img src="/info.svg" alt="" className="tw-mb-auto" />
                <div className="tw-flex tw-flex-wrap tw-gap-1">ورود شما به معنی پذیرش <span className="tw-text-[#0360D9] tw-m-0">قوانین و مقررات</span> ایزو ایونت است.</div>
                {/* <div className="tw-flex tw-gap-2 tw-items-start">
                    <span className="tw-text-nowrap">ورود شما به معنی پذیرش </span><span className="tw-text-[#0360D9] tw-text-nowrap">قوانین و مقررات</span> ایزو ایونت است.
                </div> */}
            </div>
            <a href="tel:05191770025" className="tw-m-auto tw-no-underline tw-cursor-pointer tw-w-fit tw-flex tw-items-center tw-justify-center tw-gap-1 tw-text-[#0360D9] tw-mt-3">
                <img src="/support_agent.svg" alt="support" />
                تماس با پشتیبانی
            </a>
        </>
    )
}

export default AuthFooter